import { Component } from "react"
import moment from "moment"
import {Button, Col, DatePicker, Form, Input, Radio, RadioChangeEvent, Row} from "antd"
import Utils from "../../../Util/Utils"
import SelectSuggestStaff from "../../../Component/SelectSuggestStaff"
import DefaultPropsInterface from "../../../Interface/DefaultPropsInterface"
import SelectVoucherStatus from "../../../Component/SelectVoucherStatus"

const RangePicker = DatePicker.RangePicker

const beginDateFormat = "YYYY-MM-DD HH:mm:00"
const endDateFormat = "YYYY-MM-DD HH:mm:59"

interface FormInterface {
    code?: string
    preparedBy?: string
    approvedBy?: string
    preparedAtFrom?: string
    preparedAtTo?: string
    timestampFrom?: string
    timestampTo?: string
    approvedAtFrom?: string
    approvedAtTo?: string
    approvedAt?: string
    status?: string
    transaction?: string
    ref?: string
    source?: string
    reviewStatus?:string
}

interface Props extends DefaultPropsInterface {}

interface State {
    form: FormInterface
    isShow: boolean
}

class FilterForm extends Component<Props, State> {
    state = {
        form: {
            ...Utils.getQueryFromLocation(this.props.location),
        },
        isShow: false,
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (
            JSON.stringify(this.props.location.search) !== JSON.stringify(prevProps.location.search)
            || JSON.stringify(this.props.match.params) !== JSON.stringify(prevProps.match.params)
        ) {
            this.setState({form:Utils.getQueryFromLocation(this.props.location)})
        }
    }

    handleChangeInput = (field: string, e: any) => {
        const form: any = this.state.form
        form[field] = e.target.value
        this.setState({ form })
    }

    handleChangeSelect = (field: string, value: any) => {
        const form: any = this.state.form
        form[field] = value
        this.setState({ form }, () => {
            if (field === "status") {
                this.handleFilter()
            }
        })
    }

    handleChangeRangePicker = (field: string, values: any) => {
        const { form }: any = this.state

        if (field === "timestamp") {
            form["timestampFrom"] = values && values[0] ? moment(values[0].format(beginDateFormat)).toISOString() : null
            form["timestampTo"] = values && values[1] ? moment(values[1].format(endDateFormat)).toISOString() : null
        } else if (field === "preparedAt") {
            form["preparedAtFrom"] =
                values && values[0] ? moment(values[0].format(beginDateFormat)).toISOString() : null
            form["preparedAtTo"] = values && values[1] ? moment(values[1].format(endDateFormat)).toISOString() : null
        } else if (field === "approvedAt") {
            form["approvedAtFrom"] =
                values && values[0] ? moment(values[0].format(beginDateFormat)).toISOString() : null
            form["approvedAtTo"] = values && values[1] ? moment(values[1].format(endDateFormat)).toISOString() : null
        }

        this.setState({ form })
    }

    handleFilter = () => {
        Utils.pushCleanQueryToHistory(this.props.history, this.props.location, this.state.form)
    }

    toggleFilterShow = () => {
        this.setState({ isShow: !this.state.isShow })
    }

    clearFilter = () => {
        this.setState({ form: {} })
        Utils.pushCleanQueryToHistory(this.props.history, this.props.location, {})
    }

    render() {
        const form: FormInterface = this.state.form
        const { isShow } = this.state
        const disbaleSubmit: boolean = Utils.checkDisableSubmit(form)

        return (
            <>
                <div className="font-medium  capitalize pointer space-between" onClick={this.toggleFilterShow}>
                    <span className="fsz-16px">Tìm kiếm</span>

                    <span>
                        {isShow ? <i className="fa-solid fa-chevron-up" /> : <i className="fa-solid fa-chevron-down" />}
                    </span>
                </div>

                {isShow && (
                    <Form layout={"horizontal"} className=" bottom-item-12 pd-t-12" labelAlign="left">
                        <Row gutter={20}>
                            <Col xs={24} lg={8}>
                                <Form.Item label={"Mã phiếu"} className={"label-width-medium"}>
                                    <Input
                                        placeholder={"Tìm kiếm theo mã phiếu"}
                                        value={form.code}
                                        onChange={this.handleChangeInput.bind(this, "code")}
                                        onPressEnter={() => this.handleFilter()}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Form.Item label={"Mã giao dịch"} className={"label-width-large"}>
                                    <Input
                                        placeholder={"Tìm kiếm theo mã giao dịch"}
                                        value={form.transaction}
                                        onChange={this.handleChangeInput.bind(this, "transaction")}
                                        onPressEnter={() => this.handleFilter()}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Form.Item label={"Mã bút toán"} className={"label-width-large"}>
                                    <Input
                                        placeholder={"Tìm kiếm theo mã bút toán"}
                                        value={form.ref}
                                        onChange={this.handleChangeInput.bind(this, "ref")}
                                        onPressEnter={() => this.handleFilter()}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} lg={8}>
                                <Form.Item label={"Người tạo"} className={"label-width-medium"}>
                                    <SelectSuggestStaff
                                        selectProps={{
                                            placeholder: "Người tạo",
                                        }}
                                        value={form.preparedBy}
                                        onChange={this.handleChangeSelect.bind(this, "preparedBy")}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Form.Item label={"Người xác nhận"} className={"label-width-large"}>
                                    <SelectSuggestStaff
                                        selectProps={{
                                            placeholder: "Người xác nhận GD",
                                        }}
                                        value={form.approvedBy}
                                        onChange={this.handleChangeSelect.bind(this, "approvedBy")}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} lg={8}>
                                <Form.Item label={"Thời gian giao dịch"} className={"label-width-large"}>
                                    <RangePicker
                                        className={"width-100pc"}
                                        value={[
                                            form.timestampTo ? moment(form.timestampTo) : null,
                                            form.timestampFrom ? moment(form.timestampFrom) : null,
                                        ]}
                                        placeholder={["Từ", "Đến"]}
                                        format={"DD/MM/YYYY HH:mm"}
                                        showTime={true}
                                        onChange={this.handleChangeRangePicker.bind(this, "timestamp")}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Form.Item label={"Thời gian tạo"} className={"label-width-medium"}>
                                    <RangePicker
                                        className={"width-100pc"}
                                        value={[
                                            form.preparedAtFrom ? moment(form.preparedAtFrom) : null,
                                            form.preparedAtTo ? moment(form.preparedAtTo) : null,
                                        ]}
                                        placeholder={["Từ", "Đến"]}
                                        format={"DD/MM/YYYY HH:mm"}
                                        showTime={true}
                                        onChange={this.handleChangeRangePicker.bind(this, "preparedAt")}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Form.Item label={"Thời gian xác nhận"} className={"label-width-large"}>
                                    <RangePicker
                                        className={"width-100pc"}
                                        value={[
                                            form.approvedAtFrom ? moment(form.approvedAtFrom) : null,
                                            form.approvedAtTo ? moment(form.approvedAtTo) : null,
                                        ]}
                                        placeholder={["Từ", "Đến"]}
                                        format={"DD/MM/YYYY HH:mm"}
                                        showTime={true}
                                        onChange={this.handleChangeRangePicker.bind(this, "approvedAt")}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={24} xl={8} xxl={8}>
                                <Form.Item label={"Phiếu"} className="label-width-large radio-group">
                                    <Radio.Group
                                        onChange={({ target: { value } }: RadioChangeEvent) => {
                                            this.handleChangeSelect("reviewStatus", value)
                                            this.handleFilter()
                                        }}
                                        value={form.reviewStatus}
                                        defaultValue={undefined}
                                    >
                                        <Radio value={undefined}>Tất cả</Radio>
                                        <Radio value={"REVIEWED"}>Đã duyệt</Radio>
                                        <Radio value={"PENDING"}>Chờ duyệt</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={24} xl={10} xxl={8}>
                                <Form.Item label={"Trạng thái"} className={'label-width-medium'}>
                                    <SelectVoucherStatus
                                        value={form.status || undefined}
                                        onChange={({ target: { value } }: RadioChangeEvent) => {
                                            this.handleChangeSelect.bind(this, "status", value)()
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <div className="text-right">
                            {!disbaleSubmit && (
                                <Button
                                    type={"text"}
                                    onClick={this.clearFilter}
                                    icon={<i className="fa-solid fa-repeat pd-r-4" />}
                                    className="font-size-12px"
                                >
                                    Làm mới bộ lọc
                                </Button>
                            )}
                            <Button type={"primary"} onClick={this.handleFilter} disabled={disbaleSubmit}>
                                Tìm kiếm
                            </Button>
                        </div>
                    </Form>
                )}
            </>
        )
    }
}

export default FilterForm
